<template>
  <router-link
    v-if="item.visibilityRules"
    :is="componentType"
    :to="item.routerLink"
    v-click-outside="hideSubmenu"
    :class="[
      'main-menu__item',
      {'main-menu__item_active': showSubmenu}
    ]"
    data-test-id="menu-item"
    @click.stop="toggleSubmenu"
  >
    <md-tooltip
      md-direction="right"
      :md-active.sync="tooltipActive"
      data-test-id="menu-item-tooltip"
      class="custom-menu-tooltip"
    >
      {{ item.tooltipText }}
    </md-tooltip>
    <md-icon
      class="main-menu__item-icon"
      data-test-id="menu-item-icon"
      :md-src="item.icon.includes('.svg') ? item.icon : null"
    >
      {{ !item.icon.includes('.svg') && item.icon }}
    </md-icon>
    <transition name="submenu">
      <SubmenuList
        v-show="showSubmenu"
        :submenuList="item.submenu"
        @tooltipHide="tooltipActive = false"
      />
    </transition>
  </router-link>
</template>

<script>
  import SubmenuList from './submenuList.vue'

  export default {
    name: 'main-menu-item',

    components: {
      SubmenuList
    },

    props: {
      item: { type: Object, required: false }
    },

    data () {
      return {
        tooltipActive: false,
        showSubmenu: false
      }
    },

    computed: {
      componentType () {
        return this.item.routerLink ? 'router-link' : 'button'
      }
    },

    watch: {
      showSubmenu (val) {
        this.tooltipActive = val ? !val : val
      },

      tooltipActive (newVal) {
        if (newVal && this.showSubmenu) {
          this.$nextTick(() => {
            this.tooltipActive = false
          })
        }
      }
    },

    methods: {
      toggleSubmenu () {
        if (!this.item.submenu || !this.item.submenu.length) return
        this.showSubmenu = !this.showSubmenu
      },
      hideSubmenu () { this.showSubmenu = false }
    }
  }
</script>

<style scoped lang="scss">
  @import "~scss/variables";
  @import "~scss/mixins";

  .main-menu {
    &__item {
      position: relative;
      display: flex;
      width: 44px;
      height: 44px;
      border-radius: 30px;
      justify-content: center;
      align-items: center;
      border: 1px solid $color-graphite;
      cursor: pointer;
      background-color: transparent;
      // transition: background-color 0.3s ease-in-out;
      transition: background-color .3s cubic-bezier(.4, 0, .2, 1);

      &-icon {
        text-decoration: none;
        &.md-icon {
          color: $color-graphite;

          /deep/ path,
          /deep/ rect,
          /deep/ svg {
            color: $color-graphite;
            fill: $color-graphite;
            transition: .1s;
          }
        }
      }

      &_active,
      &:hover,
      &:has(.router-link-active),
      &.router-link-active {
        background-color: $color-graphite;
        color: $color-mint;
        text-decoration: none;

        .md-icon {
          color: $color-mint;

          /deep/ path,
          /deep/ rect,
          /deep/ svg {
            color: $color-mint;
            fill: $color-mint;
            transition: .1s;
          }
        }
      }
    }
  }

  .submenu-list {
    overflow: hidden;
    will-change: transform, opacity;
  }

  .submenu-enter-active,
  .submenu-leave-active {
    transition: transform 0.25s ease, opacity 0.2s ease;
  }

  .submenu-enter, .submenu-leave-to {
    transform: translateY(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/mainMenu/menuItem.vue